import React, { useState } from 'react'
import { Checkbox, Icon, Table } from 'semantic-ui-react'
import { chooseDateAndTime } from '../../util'
import DropDown from '@commonComponents/formComponents/dropDown'

const EmergencyShipment = (props) => {
    const {
        dataSource: {
            shipmentId,
            mrn,
            acceptanceDate,
            customsState,
            isChecked
        },
        onMarkShipment,
        updateCustomState,
        translate,
        customStateMapper
    } = props
    const customStateList = getDropdown(customStateMapper)
    const [isEdit, setEdit] = useState(false)
    const [custom, setCustom] = useState(customsState)
    return (
        <Table.Row key={shipmentId}>
            <Table.Cell style={{ paddingLeft: '24px' }}>
                <Checkbox
                    label={'_'}
                    checked={isChecked}
                    onChange={(e, data) => onMarkShipment(data, shipmentId)}
                />
            </Table.Cell>
            <Table.Cell>{shipmentId}</Table.Cell>
            <Table.Cell>{mrn}</Table.Cell>
            <Table.Cell>{acceptanceDate && chooseDateAndTime(Number(acceptanceDate))}</Table.Cell>
            <Table.Cell>
                {(!isEdit && customsState === 'STATE_NOOD_RELEASED_DECL_SENT')
                    ? translate(customsState?.replace('STATE_', '')) : null}{"  "}
                {customsState !== 'STATE_NOOD_RELEASED_DECL_SENT'
                    && translate(customsState?.replace('STATE_', ''))}{"  "}
                {(isEdit && customsState === 'STATE_NOOD_RELEASED_DECL_SENT') && (
                    <div style={{display:'flex', flexDirection: 'row', textWrap:'nowrap'}}>
                        <div style={{flexGrow:'8', border:'1px solid #1765ae', borderRadius:'4px'}}>
                            <DropDown
                                id="fromCurrency"
                                label="Select Custom State"
                                className='field-bg dropdown100 border-none'
                                labelClass='text-none'
                                isLabel={true}
                                data={customStateList}
                                value={custom}
                                isDisabled={false}
                                onChange={(value) => {
                                    setCustom(value)
                                }}
                            />
                        </div>
                        <div style={{flexGrow:'2', padding:'10px'}}>
                            <Icon
                                name='save outline'
                                style={{ fontSize: '14px', cursor: 'pointer' }}
                                onClick={async () => {
                                    await updateCustomState({
                                        shipmentId,
                                        mrn,
                                        acceptanceDate,
                                        customsState: custom.replace('STATE_', '')
                                    })
                                    setEdit(preState => !preState)
                                }} />{" "}
                            <Icon
                                name='close'
                                style={{ fontSize: '14px', cursor: 'pointer' }}
                                onClick={() => {
                                    setEdit(preState => !preState)
                                    setCustom("")
                                }}
                            />
                        </div>
                    </div>
                )}
                {(!isEdit && customsState === 'STATE_NOOD_RELEASED_DECL_SENT') ?
                    <Icon
                        name='edit outline'
                        style={{ fontSize: '14px', cursor: 'pointer' }}
                        onClick={() => setEdit(preState => !preState)}
                    />
                    : null}
            </Table.Cell>
        </Table.Row>
    )
}

export default EmergencyShipment



const data = ["STATE_DMS_515CRE", "STATE_DMS_515SENT", "STATE_DMS_515REJ", 
"STATE_DMS_529ROG", "STATE_DMS_531REM", "STATE_DMS_SUPREJ", "STATE_DMS_RRDREM", "STATE_DMS_511ACK", 
"STATE_DMS_511SENT", "STATE_DMS_511REJ", "STATE_DMS_528ACC", "STATE_DMS_560CTL10", "STATE_DMS_560CTL20", 
"STATE_DMS_560CTL30", "STATE_DMS_560CTL40", "STATE_DMS_560CTL41", "STATE_DMS_560CTL42", "STATE_DMS_560CTL43", 
"STATE_DMS_560CTL44", "STATE_DMS_560CTL45", "STATE_DMS_560CTL50", "STATE_DMS_529CLE", "STATE_DMS_582REM", "STATE_DMS_583SENT", 
"STATE_DMS_583ACK", "STATE_DMS_583REJ", "STATE_DMS_583RCV", "STATE_DMS_509CAN", "STATE_DMS_SUPSENT", "STATE_DMS_SUPACK", 
"STATE_DMS_SUPRCV", "STATE_DMS_AMD", "STATE_DMS_RFI", "STATE_DMS_CRESENT", "STATE_DMS_CREACK", "STATE_DMS_CREREJ", 
"STATE_DMS_CRERCV", "STATE_DMS_514REJ", "STATE_DMS_513SENT", "STATE_DMS_513ACK", "STATE_DMS_513REJ", "STATE_DMS_513RCV", 
"STATE_DMS_504ACC", "STATE_DMS_NL_RRD", "STATE_DMS_REG", "STATE_DMS_560CTL10-50", "STATE_DMS_599EXIT"]

const getDropdown = (customStateMapper) => {
    return data?.map((customState, index) => ({
        "text_nl": customState?.replace('STATE_', ''),
        "value": customState?.replace('STATE_', ''),
        "text": customStateMapper[customState]?.text || customState?.replace('STATE_', '') || " ",
        "id": index + 1
    }))
}